import { useState } from 'react';
import styled from 'styled-components';

import { ActionButton } from '@feedback/ui';

import layout from '../../../app/layout';
import { isMobile, media } from '../../../utils/style';
import MenuIcon from '../icon/MenuIcon';

import SearchForm from '../../home/components/SearchForm';

import AsideMenuItem from './AsideMenuItem';

const Wrapper = styled.div`
  transition: all 500ms cubic-bezier(0.2, 1, 0.22, 1);
  position: fixed;
  flex-shrink: 0;
  top: -1px;
  bottom: -${layout.spacing};
  left: ${(props) =>
    props.visible
      ? `-${layout.spacing}`
      : `calc(-${layout.sidebar.width} - ${layout.spacing})`};
  display: flex;
  flex-direction: column;
  width: ${layout.sidebar.width};
  background: ${layout.sidebar.background};
  padding: 10px 10px 10px 20px;
  z-index: 99;

  ${media.small`
    transition: none;
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
  `};
`;

const MobileSidebarItem = styled(AsideMenuItem)`
  justify-content: flex-end;
`;

const MobileMenuButton = styled(ActionButton)`
  border-radius: 100%;
  width: 55px;
  height: 55px;
  padding: ${layout.spacing};
`;

type Props = {
  onSearch: (value: string) => void;
  items: Array<any>;
};
const AsideMenu = ({ onSearch, items }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openSideMenu = () => {
    setIsOpen(true);
  };
  const closeSideMenu = () => {
    setIsOpen(false);
  };

  const handleSearch = (values) => {
    closeSideMenu();

    return onSearch(values);
  };

  if (!isMobile()) {
    return null;
  }

  return (
    <div>
      <MobileMenuButton onClick={openSideMenu}>
        <MenuIcon opened={isOpen} color={layout.header.menuIcon.color} />
      </MobileMenuButton>

      <Wrapper visible={isOpen}>
        <MobileSidebarItem icon='close' route='#' onClick={closeSideMenu} />

        {!!onSearch && <SearchForm onSubmit={handleSearch} />}

        {items.map((item) => (
          <AsideMenuItem
            key={item.title}
            icon={item.icon}
            title={item.title}
            route={item.route}
            action={item.action}
            closeMenu={closeSideMenu}
          />
        ))}
      </Wrapper>
    </div>
  );
};

export default AsideMenu;
